import { Heading } from "@aidron/aidron-ds";
import styled from "styled-components";

export const PageHeading = styled(Heading)`
  font-size: ${({ size, fontSize }) => {
    if (fontSize) return fontSize;
    return size === "lg" ? "31.25px" : "25px !important";
  }};
  margin-bottom: ${({ marginBottom }) => marginBottom ?? "1rem"};
  padding: ${({ padding }) => padding ?? ""}
`;